import { AuthenticateCustomerModel } from 'api'
import { getLocalStorageFor, clearLocalStorageFor, setLocalStorageFor } from './use-local-storage'

const STORAGE_KEYS = {
  authenticatedCustomerModel: 'authenticateCustomerModel',
  token: 'token',
}

export function getLocalToken() {
  return getLocalStorageFor<string>(STORAGE_KEYS.token)
}

export const setLocalToken = setLocalStorageFor<string>(STORAGE_KEYS.token)

export function getLocalLoginRequest() {
  return getLocalStorageFor<AuthenticateCustomerModel>(STORAGE_KEYS.authenticatedCustomerModel)
}

export const setLocalLoginRequest = setLocalStorageFor<AuthenticateCustomerModel>(
  STORAGE_KEYS.authenticatedCustomerModel
)

export function clearLocalData() {
  for (const key of Object.values(STORAGE_KEYS)) {
    clearLocalStorageFor(key)
  }
}
